/**
 * @flow
 */

import React from 'react'
import { ButtonContainer, ButtonText } from './styledComponents'

class ButtonComponent extends React.Component<Props> {
  render() {
    const { children, className } = this.props
    const type = typeof children
    if (type === 'string') {
      return (
        <ButtonContainer className={className}>
          <ButtonText>{children}</ButtonText>
        </ButtonContainer>
      )
    }
    return <ButtonContainer className={className}>{children}</ButtonContainer>
  }
}

export default ButtonComponent



// WEBPACK FOOTER //
// ./src/components/IbcArcade/ButtonComponent/index.js